export default "__VITE_ASSET__F9h4qF7OyxePqfaW7sPkYA__"